module.exports = __webpack_public_path__ + "static/media/Wigglytuff_gaussian2.93744c14.png";